import { render } from "./FacilitiesQAList.vue?vue&type=template&id=acf63752"
import script from "./FacilitiesQAList.vue?vue&type=script&lang=js"
export * from "./FacilitiesQAList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__